import React, {useState} from "react";
import {connect} from "react-redux";

import PricingFiltersBody from "../PricingFilters/PricingFiltersBody";
import SvgIcons from "../../Icons/SvgIcons";


const PricingPopupAssignFeaturesFilters = (props) => {

  const {pricingGroupName} = props;

  const [filtersOpened, setFiltersOpened] = useState(false);

  const filtersClick = () => {
    setFiltersOpened(!filtersOpened);
  }

  return (
    <div className={"pr-assign__filters transition" + (filtersOpened ? " pr-assign__filters--opened" : "")}>
      <button onClick={filtersClick}
              className="link bold w-2 h-2 padding-0 link--gray3 link--green-hover font--12 flex flex--center bg-none border-none box-shadow-none">
        {SvgIcons.filter}
      </button>
      <div className="pr-assign__filters-body pt-05 pr-1 pb-1">
        {filtersOpened ? <PricingFiltersBody theme="light" groupName={pricingGroupName}/> : null}
      </div>
    </div>
  )
};

const mapStateToProps = (store) => {
  const {pricingGroupName} = store.pricingState;
  return {
    pricingGroupName,
  };
};

export default (
  connect(mapStateToProps)(PricingPopupAssignFeaturesFilters)
)
